import { forwardRef } from 'react';
import PropTypes from 'prop-types';

export const IconPlay = forwardRef(
	({ color = 'currentColor', fill, size = 24, ...rest }, ref) => {
		return (
			<svg
				ref={ref}
				xmlns="http://www.w3.org/2000/svg"
				width={size}
				height={size}
				viewBox="0 0 24 24"
				fill={fill}
				stroke={color}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
				{...rest}>
				<polygon points="5 3 19 12 5 21 5 3" />
			</svg>
		);
	}
);

IconPlay.propTypes = {
	color: PropTypes.string,
	size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

IconPlay.displayName = 'IconPlay';
